(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/gaming-info/gaming-limits.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/gaming-info/gaming-limits.js');

'use strict';

svs.player_login.views.GamingLimits = Marionette.View.extend({
  template(data) {
    return svs.player_login.templates.gaming_limits(data);
  },
  ui: {
    limitItems: '.js-player-login-limits-item'
  },
  templateContext() {
    return {
      showNavigation: this.limits.length > 1,
      hasCasinoLimits: this.hasCasinoLimits,
      hasDepositLimits: this.hasDepositLimits,
      hasTimeLimits: this.hasTimeLimits,
      noLimits: this.limits.length < 1,
      returnUrl: this.options.returnUrl,
      isPnp: this.options.isPnp,
      pnpContinueUrl: this.options.pnpContinueUrl
    };
  },
  modelEvents: {
    sync: 'setSync',
    error: 'setError',
    'change:hasSync': 'render',
    'change:hasError': 'render'
  },
  behaviors: [svs.player_login.behaviors.Navigation],
  model: new svs.player_login.models.GamingLimits(),
  initialize() {
    this.model.fetch();
  },
  setSync() {
    function anyLimit() {
      let limitType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return Object.keys(limitType).some(limitPeriod => limitType[limitPeriod].limit);
    }
    this.hasDepositLimits = anyLimit(this.model.get('deposit') || {});
    this.hasCasinoLimits = anyLimit(this.model.get('casino') || {});
    this.hasTimeLimits = anyLimit(this.model.get('time') || {});
    this.limits = [];
    this.hasDepositLimits && this.limits.push('insättningsgränser');
    this.hasCasinoLimits && this.limits.push('förlustgränser - casino');
    this.hasTimeLimits && this.limits.push('tidsgränser');
    this.model.set('hasSync', true);
  },
  setError() {
    this.model.set('hasError', true);
  }
});

 })(window);